import axios, { AxiosInstance } from 'axios'
import API_CONFIG from "../config/api.config";
import authRepository from './auth.repository'

export type FeatureName =
  | "COMING_FEATURE_DUELS1VS1"
  | "COMING_FEATURE_QUEST"
  | "COMING_FEATURE_LEAGUES";

export type VoteType = "NOT_INTERESTED" | "INTERESTED";

export interface CreateFeatureVotePayload {
  featureName: FeatureName;
  voteType: VoteType;
  description: string;
}

export interface FeatureVoteResponse {
  id: number;
  createdAt: string;
  voteType: VoteType;
  description: string;
  userId: number;
  featureName: FeatureName;
}

class FeatureVotesRepository {
   private api: AxiosInstance;
  constructor() {
    this.api = axios.create({
      timeout: API_CONFIG.TIMEOUT,
      headers: { "Content-Type": "application/json" },
    });

    this.api.interceptors.request.use((config) => {
      const authHeaders = authRepository.getAuthHeader();
      if (authHeaders) config.headers = { ...config.headers, ...authHeaders };
      return config;
    });

    this.api.interceptors.response.use(
      (r) => r,
      (error) => {
        if (error.response?.status === 401) {
          authRepository.clearAuthData();
          window.location.href = "/broker/login";
        }
        return Promise.reject(error);
      },
    );
  }

  async createFeatureVote(
    payload: CreateFeatureVotePayload,
  ): Promise<FeatureVoteResponse> {
    const response = await this.api.post(API_CONFIG.FEATURE_VOTES.CREATE, payload);
    return response.data;
  }

  async getFeatureVoteByUserAndFeature(
    userId: number,
    featureName: FeatureName,
  ): Promise<FeatureVoteResponse[]> {
    const response = await this.api.get(API_CONFIG.FEATURE_VOTES.GET_BY_USER_AND_FEATURE, {
      params: { userId, featureName },
    });
    return response.data;
  }
}

export default new FeatureVotesRepository();
